import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import translations from "../../../assets/locals/translations";

import {
  addManufacturerToDb,
  clearAddManufacturer,
} from "../../../redux/slices/Master/Manufacturer/addManufacturerSlice";
import { setShowMessage } from "../../../redux/slices/notificationSlice";
import { Modal, Button, Spinner } from "react-bootstrap";
import {
  getAllManufacturerAction,
  getManufacturerById,
  editeManufacturerAction,
  deleteManufacturerAction,
  editManufacturerAction,
} from "./getEditeManufacturer";
import AlertDeleteModal from "../../AlertDelete/AlertDeleteModal";
import axios from "axios";

export default function Manufacturer_modal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const rowData = useSelector((state) => state.manufactureModal);
  const [modalShow, setModalShow] = React.useState(false);
  const [manufacturerID, setManufacturerID] = useState(null);
  const [modalList, setModalist] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  //---- Delete Modal Variable -----//
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);

  const [data, setData] = useState({
    manufacturerName: rowData.manufacturerName || "",
    roleDescription: rowData.manufacturerDescription || "",
  });
  const [loading, setLoading] = useState(false);
  const [isSubmittingModal, setIsSubmittingModal] = useState(false);
  const [formData, setFormData] = useState({
    modalName: "",
    modalLink: "",
    file: null,
    fileName: "",
    fileType: "",
    modalUrl: "",
    modal_id: "",
    document_id: "",
  });

  const onChangeHandler = (e) => {
    const { name, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      setFormData((prevData) => ({
        ...prevData,
        [name]: file,
        fileName: file ? file.name : "",
        fileType: file ? file.type : "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: e.target.value,
      }));
    }
  };

  useEffect(() => {
    if (rowData) {
      setManufacturerID(rowData.manufacturerId);
    }
  }, [rowData]);

  const handleModalSubmit = async () => {
    // Without this guard, a double-click (or a slow request plus an
    // impatient second click) fires two identical "add" requests before the
    // first one closes the modal, inserting the same modal twice.
    if (isSubmittingModal) return;
    setIsSubmittingModal(true);
    console.log(formData);
    let action = isEditMode ? "edit" : "add";
    formData["manufacturerId"] = rowData.manufacturerId;
    formData["action"] = action;
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/new-modal`;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.post(url, formData, config).then((response) => {
      if (response.data && response.data.isSuccess) {
        setFormData({
          modalName: "",
          modalLink: "",
          file: null,
          fileName: "",
          fileType: "",
          modalUrl: "",
          modal_id: "",
          document_id: "",
        });
        handleClose();
        getModalList();
        dispatch(setShowMessage("Data Successfully Saved."));
      }
    }).finally(() => {
      setIsSubmittingModal(false);
    });
  };

  const redirectManufacurer = () => {
    navigate(-1);
  };

  const redirectToVariantScreen = (rmdata) => {
    navigate("/administration/configuration/manufacture/modal/variants", {
      state: { rowData: rmdata },
    });
  };

  const getModalList = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/getmodal-list/${manufacturerID}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    setLoading(true);
    await axios.get(url, config).then((response) => {
      if (response.data && response.data.isSuccess) {
        console.log(response.data.result);
        setModalist(response.data.result);
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    if (manufacturerID) {
      getModalList();
    }
  }, [manufacturerID]);

  const handleShow = () => {
    setModalShow(true);
  };
  const handleClose = () => {
    setFormData({
      modalName: "",
      modalLink: "",
      file: null,
      fileName: "",
      fileType: "",
      modalUrl: "",
      modal_id: "",
      document_id: "",
    });
    setModalShow(false);
    setIsEditMode(false);
  };

  const editModal = (row) => {
    setFormData({
      modalName: row.modalName || "",
      modalLink: row.link || "",
      file: null,
      fileName: row.modalUrl.split("/").pop() || "",
      fileType: row.modalUrl.split(".").pop() || "",
      modalUrl: row.modalUrl || "",
      modal_id: row.id || "",
      document_id: row.document_id || "",
    });
    setIsEditMode(true);
    setModalShow(true);
  };

  const deleteManufacturerAlert = () => {
    setDisplayConfirmationModal(true);
    setType("modal_delete");
    setId(manufacturerID);
    setDeleteMessage(
      `${t.areyousuredeletemodal || 'Are You Sure You Want To Delete The Modal'} '${Array.isArray(rowData)
        ? rowData.map((val) => val.manufacturerName).join(", ")
        : rowData.manufacturerName
      }'?`
    );
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const submitDelete = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/deletemanufacturer`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    const requestData = {
      manufacturerId: manufacturerID,
    };

    await axios.post(url, requestData, config).then((response) => {
      if (response.data && response.data.isSuccess) {
        console.log(response.data.result);
        hideConfirmationModal();
        redirectManufacurer();
        dispatch(setShowMessage("Manufacturer Sucessfully Deleted."));
      }
    });
  };

  const handleEditClick = async (id) => {
    if (isEditing) {
      try {
        editManufacturerAction(data, id).then((response) => {
          dispatch(setShowMessage("Changes Saved!"));
        });
      } catch (error) {
        console.error("Error saving data:", error);
        alert("Failed to save data");
      }
    }
    // Toggle edit mode
    setIsEditing(!isEditing);
  };

  const handleCancel = () => {
    setData({
      manufacturerName: rowData.manufacturerName,
      roleDescription: rowData.roleDescription,
    });
    setIsEditing(false);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (onChangeHandler) onChangeHandler(e);
  };

  const inputStyle = {
    resize: "none",
    transition: "border 0.1s ease, box-shadow 0.1s ease",
    border: isEditing ? "1px solid #d7dbdd" : "1px solid #bdc3c7", // Green border in edit mode
    boxShadow: isEditing ? "0 0 8px rgba(128, 128, 128, 0.6)" : "none", // Subtle glow in edit mode
    outline: "none", // Remove default focus outline
    padding: "8px",
    borderRadius: "4px",
  };

  const renderFilePreview = () => {
    const { file, fileType, modalUrl } = formData;

    if (file) {
      // Handle preview for locally selected files
      if (fileType.startsWith("image/")) {
        return (
          <img
            src={URL.createObjectURL(file)}
            alt="Preview"
            className="img-thumbnail"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        );
      } else if (fileType === "application/pdf") {
        return (
          <embed
            src={URL.createObjectURL(file)}
            type="application/pdf"
            width="100%"
            height="400px"
          />
        );
      } else {
        return (
          <div className="file-preview">
            <h6>File Preview:</h6>
            <p className="text-muted">{formData.fileName}</p>
            <p className="text-info">
              Preview not available for this file type.
            </p>
          </div>
        );
      }
    } else if (modalUrl) {
      // Handle preview for server-provided files
      const linkFileType = fileType || modalUrl.split(".").pop();

      if (linkFileType.match(/(jpg|jpeg|png|gif)$/i)) {
        return (
          <img
            src={modalUrl}
            alt="Preview"
            className="img-thumbnail"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        );
      } else if (linkFileType === "pdf") {
        return (
          <embed
            src={modalUrl}
            type="application/pdf"
            width="100%"
            height="400px"
          />
        );
      } else {
        return (
          <div className="file-preview">
            <h6>File Preview:</h6>
            <a href={modalUrl} target="_blank" rel="noopener noreferrer">
              {formData.fileName || "Download File"}
            </a>
            <p className="text-info">
              Preview not available for this file type.
            </p>
          </div>
        );
      }
    }

    return null; // No file or URL to preview
  };

  return (
    <>
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-10 col-md-10 col-sm-10">
                <div className="d-flex align-items-center">
                  <li className="d-flex align-items-center p-2">
                    <main className="d-flex align-items-center">
                      <div className="myBtnRight">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          className="bi bi-chevron-double-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                          />
                        </svg>
                      </div>
                      <span className="ms-2">{rowData.manufacturerName}</span>
                    </main>
                  </li>
                </div>
              </div>
              <div className="col-2 col-md-2 col-sm-2">
                <div className="d-flex justify-content-end">
                  <button
                    className="myActionBtn m-1"
                    onClick={() => {
                      deleteManufacturerAlert();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-trash3"
                      viewBox="0 0 16 16"
                    >
                      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                    </svg>
                  </button>
                  <Button
                    className="rounded-pill mx-1"
                    variant="btn btn-warning"
                    onClick={() => redirectManufacurer()}
                  >
                    {t.back || 'Back'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <section className="d-flex  flex-column col-12 col-lg-5 mt-2">
            <label className="myLabel mx-4" htmlFor="email">
              {t.manufacturername || 'Manufacturer Name'}
            </label>
            <input
              disabled={!isEditing} // Enable input only in edit mode
              className="myInput mx-4"
              name="manufacturerName"
              defaultValue={data.manufacturerName}
              onChange={handleInputChange}
              style={inputStyle}
            />
          </section>
          <section className="d-flex mt-3 flex-column col-12">
            {/* Label and Edit Button */}
            <div className="d-flex justify-content-between align-items-center mx-4 mb-2">
              <label className="myLabel" htmlFor="description">
                {t.description || 'Description'}
              </label>
            </div>
            {/* Description Input */}
            <textarea
              rows="5"
              disabled={!isEditing} // Enable input only in edit mode
              defaultValue={data.roleDescription}
              className={`myInput inputElement mx-4 ${isEditing ? "editable-border" : ""
                }`}
              autoComplete="off"
              onChange={handleInputChange}
              type="text"
              name="roleDescription"
              placeholder="Enter manufacturer description"
              style={inputStyle}
            />
            {/* Label and Edit Button */}
            <div className="d-flex justify-content-between align-items-center mx-4 mb-2 mt-2">
              <button
                onClick={() => {
                  handleEditClick(rowData.manufacturerId);
                }}
                className={`btn ${isEditing ? "btn-success" : "btn-outline-primary"
                  } btn-sm`}
              >
                {isEditing ? t.save || 'Save' : t.edit || 'Edit'}
              </button>
              {isEditing && (
                <button
                  onClick={handleCancel}
                  className="btn btn-outline-danger btn-sm"
                  style={{ padding: "8px 16px" }}
                >
                  {t.cancel || 'Cancel'}
                </button>
              )}
            </div>
          </section>
          <section className="py-3">
            <div className="container">
              {/* Header */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h5 className="fw-bold">{t.modallist || 'Modal List'}</h5>
                <button
                  onClick={handleShow}
                  className="btn btn-outline-primary d-flex align-items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-plus-circle me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                  {t.addmodal || 'Add Modal'}
                </button>
              </div>

              {/* Separator */}
              <hr />

              {/* Content */}
              <ul className="list-unstyled">
                {loading ? (
                  <div className="d-flex justify-content-center py-5">
                    <Spinner style={{ color: "rgb(132, 211, 227)" }} />
                  </div>
                ) : (
                  modalList.map((row, index) => (
                    <li key={index} className="row align-items-center">
                      <div className="col-12 col-sm-8 d-flex align-items-center py-2 px-3">
                        <div
                          className="d-flex justify-content-between align-items-center btn btn-light w-100"
                          style={{ cursor: "pointer" }}
                        >
                          <div
                            onClick={() => redirectToVariantScreen(row)}
                            className="d-flex align-items-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-chevron-double-right me-2"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                              />
                              <path
                                fillRule="evenodd"
                                d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                              />
                            </svg>
                            <span>{row.modalName}</span>
                          </div>
                          <button
                            className="myActionBtn"
                            onClick={() => editModal(row)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              className="bi bi-pencil-square"
                              viewBox="0 0 16 16"
                            >
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path
                                fillRule="evenodd"
                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </section>
        </div>
      </div>
      <AlertDeleteModal
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={id}
        message={deleteMessage}
      />
      {/* Add Modal */}
      <Modal show={modalShow} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? t.editmodal || 'Edit Modal' : t.addmodal || 'Add Modal'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="mb-3">
                <label htmlFor="modalName" className="col-form-label">
                  {t.modalname || 'Modal Name:'}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="modalName"
                  name="modalName"
                  value={formData.modalName}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="modalLink" className="col-form-label">
                  {t.modallink || 'Modal Link:'}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="modalLink"
                  name="modalLink"
                  value={formData.modalLink}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="file" className="col-form-label">
                  {t.brochurefile || 'Brochure File:'}
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="file"
                  name="file"
                  onChange={onChangeHandler}
                />
              </div>
              {(formData.file || formData.modalUrl) && (
                <div className="mt-3">
                  <h6>Brochure:</h6>
                  {renderFilePreview()}
                </div>
              )}
            </div>
            <div className="card-footer text-center">
              <Button
                variant="warning mx-2"
                onClick={() => redirectManufacurer()}
              >
                {t.cancel || 'CANCEL'}
              </Button>
              <Button variant="success mx-2" onClick={handleModalSubmit} disabled={isSubmittingModal}>
                {isEditMode ? t.update || 'UPDATE' : t.save || 'SAVE'}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
